<template>
  <!-- 模拟器练习详情 -->
  <gradeDetail></gradeDetail>
</template>
<script>
import gradeDetail from '../gradeDetail'
import withRouteTracking from '@/utils/withRouteTracking'
import { getShareInfo } from '@/utils/wxShare'
const UserProfile = {
  components: {
    gradeDetail
  },
  data() {
    return {}
  },
  created() {
    this.handleShareMethod()
  },
  methods: {
    handleShareMethod() {
      window.sessionStorage.setItem('mainId', this.postId)
      window.sessionStorage.setItem('serviceId', this.postId)
      let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : ''
      window.sessionStorage.setItem('entrance', entrance)
      getShareInfo({
        title: 'iEP-中国电生理术者充电站',
        titleTimeLine: 'iEP-中国电生理术者充电站',
        desc: '更智慧、更全面、更懂你。',
        link: window.location.href,
        linkTimeLine: window.location.href,
        images: `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
      })
    },
  }
}
export default withRouteTracking(UserProfile)
</script>



// WEBPACK FOOTER //
// src/views/grade/components/mockDetail.vue